import styled from "styled-components";

import { TextButton } from "components/vote/Votebox/common/Buttons/TextButton";
import { SortButtonStyleProps } from "components/vote/Votebox/common/types";
import {
    VOTEBOX_ACCENT_COLOR,
    VOTEBOX_BORDER_WIDTH,
    VOTEBOX_FONT_SIZE_CAPTION,
    VOTEBOX_FONT_SIZE_SMALL,
    VOTEBOX_FONT_WEIGHT_BOLD,
    VOTEBOX_PILL_BUTTON_HEIGHT,
    VOTEBOX_ROW_GAP,
    VOTEBOX_SECONDARY_TEXT_COLOR,
    VOTEBOX_SMALL_ICON_SIZE,
    VOTEBOX_WHITE,
} from "components/vote/Votebox/common/voteboxTokens";

export const Wrapper = styled.div`
    margin-top: 15px;
`;

// Voices counter and sort button share a line, the button at its end.
export const ToolbarRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: ${VOTEBOX_ROW_GAP};
    margin-bottom: 1rem;
    &:empty {
        display: none;
    }
`;

export const StyledNumberOfVoices = styled.div`
    color: ${VOTEBOX_SECONDARY_TEXT_COLOR};
    font-size: ${VOTEBOX_FONT_SIZE_SMALL};
`;

export const StyledSortSelection = styled(TextButton)<SortButtonStyleProps>`
    display: flex;
    align-items: center;
    gap: 6px;
    min-height: ${VOTEBOX_PILL_BUTTON_HEIGHT};
    margin-inline-start: auto;
    padding: 0 12px;
    border: ${VOTEBOX_BORDER_WIDTH} solid ${VOTEBOX_ACCENT_COLOR};
    border-radius: 18px;
    background: ${(props) =>
        props.$isPressed ? VOTEBOX_ACCENT_COLOR : VOTEBOX_WHITE};
    color: ${(props) =>
        props.$isPressed ? VOTEBOX_WHITE : VOTEBOX_ACCENT_COLOR};
    font-size: ${VOTEBOX_FONT_SIZE_CAPTION};
    font-weight: ${VOTEBOX_FONT_WEIGHT_BOLD};
    cursor: pointer;
    .MuiSvgIcon-root {
        font-size: ${VOTEBOX_SMALL_ICON_SIZE};
    }
`;
